import {memo, useEffect, useState} from "react";
import {DatePicker} from "antd";
import dayjs from "dayjs";
import {handleRequest, apiError} from "~/utils";
import {dashboardApi} from "~/api";
import FontAwesomeIcon from "~/components/FontAwesome";
import {Image} from "~/components";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Widget dashboard đào tạo: danh sách NV kinh doanh KHÔNG có lịch tư vấn trong ngày.
 * Cho chọn ngày (mặc định hôm nay); gọi dashboardApi.saleNoConsultation({date}).
 */
function NoConsultationWidget({
	title = 'không có lịch tư vấn',
	icon = 'fa-light fa-calendar-xmark',
	gradient = 'linear-gradient(135deg, #b45309 0%, #e47d0a 60%, #f59e0b 100%)',
}) {

	const [date, setDate]       = useState(dayjs());
	const [items, setItems]     = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let mounted = true;
		setLoading(true);
		handleRequest(dashboardApi.saleNoConsultation({date: date.startOf('day').unix()})).then(([err, res]) => {
			if (!mounted) return;
			if (!apiError('', err, res) && res?.data) {
				setItems(res.data);
			}
			setLoading(false);
		});
		return () => { mounted = false; };
	}, [date]);

	const datePicker = (
		<DatePicker
			size="small"
			format="DD/MM/YYYY"
			allowClear={false}
			value={date}
			onChange={(value) => { if (value) setDate(value); }}
			style={{width: 130}}
		/>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(245,158,11,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon={icon}
				title={title}
				gradient={gradient}
				badge={items.length > 0 ? `${items.length} người` : null}
				extra={datePicker}
			/>

			<div style={{padding: '12px 18px'}}>
				{loading && (
					<div style={{textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 13}}>
						<FontAwesomeIcon icon="fa-light fa-loader" spin style={{marginRight: 6}} />
						Đang tải...
					</div>
				)}

				{!loading && items.length === 0 && (
					<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
						<FontAwesomeIcon icon="fa-light fa-circle-check" style={{fontSize: 26, display: 'block', marginBottom: 6, color: '#10b981'}} />
						<span style={{fontSize: 12}}>Tất cả NV đều có lịch tư vấn</span>
					</div>
				)}

				{!loading && items.map((item, index) => {
					const name   = item.firstname ? `${item.firstname} ${item.lastname}` : `#${item.id}`;
					const isLast = index === items.length - 1;

					return (
						<div key={`no-consultation-${item.id}`} style={{
							display: 'flex', gap: 10, alignItems: 'center',
							paddingBottom: isLast ? 4 : 12, marginBottom: isLast ? 0 : 12,
							borderBottom: isLast ? 'none' : '1px dashed #e2e8f0',
						}}>
							<div className="avatar" style={{width: 40, height: 40, flexShrink: 0}}><Image src={item.avatar} /></div>

							<div style={{flex: 1, minWidth: 0}}>
								<b style={{fontSize: 13, color: '#1e293b', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{name}</b>
								<p style={{fontSize: 11, color: '#64748b', margin: 0}}>{item.username}</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default memo(NoConsultationWidget);
